import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IAuthService } from '../interfaces/i-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard  {

  constructor(
    @Inject('IAuthService') private auth: IAuthService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ){
    if(await this.auth.isLoggedIn()) {
      return true;
    } else {
      this.auth.redirectToLoginPage();
      return false;
    }
  }

}
